/* Nydo Circle — shared behavior for all nydo-circle-* sections.
   Every section loads this file with defer; the guard below makes sure
   it only initializes once per page even when several sections include it. */

(function () {
  if (window.__nydoCircleInit) return;
  window.__nydoCircleInit = true;

  function init() {
    /* Hide the theme's own page-title <h1> so the hero heading is the only h1.
       Only needed when the theme's page template prints a title above sections. */
    try {
      var roots = document.querySelectorAll('.nyc-scope');
      if (roots.length) {
        var main = document.querySelector('main') || document.getElementById('MainContent') || document.body;
        var headings = main.querySelectorAll('h1');
        outer:
        for (var i = 0; i < headings.length; i++) {
          for (var j = 0; j < roots.length; j++) {
            if (roots[j].contains(headings[i])) continue outer;
          }
          headings[i].style.display = 'none';
        }
      }
    } catch (e) {}

    /* Referral form. Message texts come from data attributes set in the
       section schema, so they stay editable in the theme editor. */
    var form = document.getElementById('nyc-referral-form');
    var emailInput = document.getElementById('nyc-email');
    var message = document.getElementById('nyc-form-message');

    if (form && emailInput && message) {
      var successText = form.getAttribute('data-success-text') ||
        'Danke. Wenn Deine E-Mail-Adresse für den nydo Circle berechtigt ist, erhältst Du Deinen persönlichen Link in Kürze per E-Mail.';
      var invalidText = form.getAttribute('data-invalid-text') ||
        'Bitte gib eine gültige E-Mail-Adresse ein.';

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var email = emailInput.value.trim();
        var isValid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);

        if (!isValid) {
          message.textContent = invalidText;
          message.classList.add('is-visible');
          return;
        }

        /* Send the request to Klaviyo via the store's onsite snippet (company TWZD7Q).
           Identifies the profile and logs a "Requested nydo Circle Link" event,
           which triggers the Klaviyo flow that checks eligibility and emails the link. */
        try {
          window.klaviyo = window.klaviyo || [];
          window.klaviyo.push(['identify', { '$email': email }]);
          window.klaviyo.push(['track', 'Requested nydo Circle Link', {
            email: email,
            source: 'nydo-circle-page'
          }]);
        } catch (e) {}

        message.textContent = successText;
        message.classList.add('is-visible');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* CTA tracking — delegated once for the whole page. */
  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-referral-event]');
    if (!target) return;

    var eventName = target.getAttribute('data-referral-event');

    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({
        event: 'nydo_circle_cta',
        referral_event: eventName
      });
    }
  });
})();
